import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const loadLogoImage = async () => {
  try {
    const logoResponse = await fetch('/images/lixani_logo_black.png');
    const logoBlob = await logoResponse.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.readAsDataURL(logoBlob);
    });
  } catch (error) {
    return null;
  }
};

export const downloadCanvasAsPdf = async (canvasRef, filename = 'areaplan') => {
  if (!canvasRef.current) return;

  const canvasContainer = canvasRef.current.parentElement;
  const logoDataURL = await loadLogoImage();

  const canvas = await html2canvas(canvasContainer, {
    useCORS: true,
    allowTaint: true,
  });

  const imgData = canvas.toDataURL('image/jpeg', 0.8);
  const isLandscape = canvas.width > canvas.height;

  const pdf = new jsPDF({
    orientation: isLandscape ? 'landscape' : 'portrait',
    unit: 'mm',
    format: 'a4',
  });

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const margin = 10;

  if (logoDataURL) {
    pdf.addImage(logoDataURL, 'PNG', margin, margin, 30, 12);
  }

  const availableWidth = pageWidth - 2 * margin;
  const availableHeight = pageHeight - 2 * margin - 20;
  const imgRatio = canvas.width / canvas.height;

  let imgWidth, imgHeight;
  if (availableWidth / availableHeight > imgRatio) {
    imgHeight = availableHeight;
    imgWidth = imgHeight * imgRatio;
  } else {
    imgWidth = availableWidth;
    imgHeight = imgWidth / imgRatio;
  }

  const imgX = (pageWidth - imgWidth) / 2;
  const imgY = margin + 15;

  pdf.addImage(imgData, 'JPEG', imgX, imgY, imgWidth, imgHeight);

  pdf.setFontSize(10);
  pdf.setTextColor('#32C1D9');
  pdf.textWithLink('www.lixani.com', pageWidth / 2, pageHeight - 5, {
    url: 'https://lixani.com',
    align: 'center',
  });

  pdf.save(`${filename}.pdf`);
};
